import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import fieldsReducer from 'modules/settings/quoteCreation/smartRfqSettings/data/reducer';
import fieldsSaga, {
  initSaga as fieldsInitSaga,
} from 'modules/settings/quoteCreation/smartRfqSettings/data/sagas';

const initSaga = function* () {
  yield all([fieldsInitSaga()]);
};

const reducer = combineReducers({
  fields: fieldsReducer,
});

const saga = function* () {
  yield all([fieldsSaga()]);
};

export { initSaga, reducer, saga };
